import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"

interface UpdateSavedBillsPayload {
  id: string;
  service_name: string;
  name: string;
  sub_title: string;
}

export const updateSavedBills = (payload: UpdateSavedBillsPayload) => {
  return axiosPrivate.put(`/bills/api/v1/saved-bills/`, payload)
}
